import { Component, OnInit, Optional, Inject } from '@angular/core';
import { HistoryCommunicateService } from '../../services/History-communicate.services';
import {RouterModule} from '@angular/router';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'new-history-summary',
    templateUrl: './history-summary.component.html',
    styleUrls: ['history-summary.component.css']
})
export class NewHistorySummaryComponent implements OnInit {
  summary: any;
  activeSort: String;
  reverseSort: boolean;
  acctRef: any;
  loading: boolean = true;
  error: boolean = false;
  currentTimestamp: any;
  ismobile: boolean = false;
  isAdaTheme: boolean = false;
  constructor(
    private historycommunicate: HistoryCommunicateService,
    private router: RouterModule, private translationService: PershingTranslationService,
    @Optional() @Inject('AppSettings') appSettings: any) {
      this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
      if (appSettings.deviceType && appSettings.deviceType === 'mobile') {
        this.ismobile = true;
      }
      if (appSettings.themeType && appSettings.themeType === 'ada') {
        this.isAdaTheme = true;
      }
    }
  ngOnInit() {
    if (this.historycommunicate.subsVar === undefined) {
      this.historycommunicate.subsVar = this.historycommunicate.
      invokeFirstComponentFunction.subscribe((name: string) => {
      this.firstFunction();
      });
    }
    if (this.historycommunicate.subsVar2 === undefined) {
      this.historycommunicate.subsVar2 = this.historycommunicate.
      loading.subscribe((name: string) => {
      this.initiateLoading();
      });
    }
  }
  firstFunction() {
    this.summary = this.historycommunicate.getSummary();
    if (this.summary === undefined) {
      this.error = true;
    }
    if (this.summary !== null && this.summary !== undefined) {
      this.reverseSort = !this.reverseSort;
      this.sort(this.activeSort);
    }
    this.loading = false;
    this.currentTimestamp = this.historycommunicate.getAsOf();
  }
  initiateLoading() {
    this.summary = undefined;
    this.loading = true;
    this.error = false;
  }
  sort(att) {
    if (this.summary !== null && this.summary !== undefined) {
      for (let i of this.summary) {
        i.showDiv = false;
      }
      if ( att === this.activeSort) {
        this.reverseSort = !this.reverseSort;
        if (!this.reverseSort) {
          this.summary.reverse();
        }else {
          this.summary.reverse();
        }
      }else {
        this.activeSort = att;
        this.reverseSort = false;
        this.summary.sort((a, b) => (a[att] > b[att]) ? 1 : -1);
      }
    }
  }
}
